import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useContent } from "@/lib/content";

export const FloatingCTA = () => {
  const { hero } = useContent();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isLayoutVisible = (el) => !!el && el.offsetParent !== null;
    const getTarget = () => {
      const mobile = document.querySelector('[data-testid="hero-cta-button-mobile"]');
      if (isLayoutVisible(mobile)) return mobile;
      const desktop = document.querySelector('[data-testid="hero-cta-button"]');
      if (isLayoutVisible(desktop)) return desktop;
      return null;
    };
    const onScroll = () => {
      const t = getTarget();
      if (!t) {
        setVisible(false);
        return;
      }
      const rect = t.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const go = (e) => {
    e.preventDefault();
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          key="floating-cta"
          href="#contact"
          onClick={go}
          data-testid="floating-cta"
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed top-[72px] md:top-[88px] left-4 md:left-8 z-40 inline-flex items-center rounded-full bg-burgundy px-4 md:px-5 py-2 md:py-2.5 text-[10px] md:text-[11px] font-semibold uppercase tracking-[0.25em] md:tracking-[0.3em] text-ivory shadow-md hover:bg-charcoal transition-colors duration-300"
        >
          {hero.cta}
        </motion.a>
      )}
    </AnimatePresence>
  );
};
